import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {
  EmpresasShowDialogComponent,
  BaseDialogMapDetailComponent,
  ChacrasMapDetailComponent,
  ListSearchComponent, TipoRendimientoSelectComponent,
} from "./components";
import {BaseCrudComponent} from "./base";
import {
  ChacraFormComponent,
  ZonasExclusionFormComponent
} from './components/forms';
import {ChacraCoreModule} from "../../chacra-core/chacra-core.module";


const components = [
  // dialogs
  EmpresasShowDialogComponent,
  BaseDialogMapDetailComponent,
  // Components
  BaseCrudComponent,
  ChacrasMapDetailComponent,
  ListSearchComponent,
  TipoRendimientoSelectComponent,
  //Forms
  ChacraFormComponent,
  ZonasExclusionFormComponent,
];

@NgModule({
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  declarations: [...components],
  imports: [
    ChacraCoreModule
  ],
  exports: [
    ChacraCoreModule,
    ...components
  ]
})
export class CommonFeaturesModule {
}
